import { useNavigation } from "react-router";

/** A thin bar at the top while a page's data loads, so a slow signal never looks frozen. */
export function NavProgress() {
  const navigation = useNavigation();
  if (navigation.state === "idle") return null;
  return (
    <div
      role="progressbar"
      aria-label="Loading"
      className="fixed inset-x-0 top-0 z-50 h-1 overflow-hidden bg-brand/20"
    >
      <div className="h-full w-1/3 animate-[sq-progress_1s_ease-in-out_infinite] bg-brand" />
    </div>
  );
}
